import { Component, OnInit, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { CommonService } from 'src/app/services/common.service';
import { BillersService } from '../../services/billers.service'

declare var webengage
@Component({
  selector: 'app-add-biller',
  templateUrl: './add-biller.component.html',
  styleUrls: ['./add-biller.component.scss']
})
export class AddBillerComponent implements OnInit {

  @ViewChild("toggleAccordian") toggleButton:ElementRef
  @Output() onBillerAdded=new EventEmitter()


  countries = []

  billers = []
  billersNew = []
  categories = {}
  categoriesName = []
  inputs = []
  biller_name:string = ''
  data:object
  validate = true
  constructor(public billerService:BillersService, public common : CommonService) { }

  ngOnInit(): void {
    this.billerService.getCountries().subscribe(res => {
      //console.log(res)
      this.countries = res['biller_countries']
    })
  }

  onSelectCountry(country){
    this.billerService.common.showLoader()
    this.billers = []
    this.inputs = []
    this.categories = {}
    this.categoriesName = []
    this.billersNew = []
    if(country)
    {
      this.billerService.getBillers(country).subscribe((res)=>{
      this.billers = res['biller_catalog']
      this.billers.forEach((biller)=>{
        if(this.categories[biller.biller_type]){
            this.categories[biller.biller_type].push(biller.biller_name)
        }
        else{
          this.categories[biller.biller_type] = new Array()
          this.categories[biller.biller_type].push(biller.biller_name)
        }
        
      })
      //console.log(Object.keys(this.categories))
      this.categoriesName = Object.keys(this.categories)
      this.billerService.common.stopLoader()
      },err =>{
        this.billerService.message.add({severity:'error', summary: 'Something went wrong', detail: 'Please try again later!'})
        this.billerService.common.stopLoader()
      })
    }
    else{
      this.billers = []
      this.inputs = []
      this.billerService.common.stopLoader()
    }
  }

  onSelectCategory(category){
    this.inputs = []
    this.billersNew = []
    this.billers.forEach((biller)=>{
      if(biller.biller_type == category)
        this.billersNew.push( biller )
    })
    
  }

  onSelectBiller(my_event){
    this.inputs = []
    this.billerService.common.showLoader()
    this.biller_name = my_event.options[my_event.selectedIndex].innerText
    // this.options[this.selectedIndex].getAttribute('isred')
    // //console.log(my_event.options[my_event.selectedIndex].innerText)
    if(my_event.value){
      this.billerService.getSkuCatalog(my_event.value).subscribe((res)=>{
        // //console.log(res)
        this.inputs = res['sku_io_catalog']
        this.billerService.common.stopLoader()
      },err =>{
        this.billerService.message.add({severity:'error', summary: 'Something went wrong', detail: 'Please try again later!'})
        this.billerService.common.stopLoader()
      })

    }
  }

  addBiller(billerForm : NgForm){
    // //console.log(typeof billerForm.value)
    this.common.showLoader()
    this.data = {...billerForm.value, ...{biller_name : this.biller_name}}
    if(!this.data['nick_name']){
      this.billerService.message.add({ severity: 'error', summary: 'No nick name', detail: 'Please enter nick name!' })
      this.common.stopLoader()
      return
    }
    this.billerService.addBiller(this.data)
      .subscribe((res)=>{
      // //console.log(res)
      this.common.stopLoader()
      if(res['result'])
        this.onBillerAdded.emit(true)
        webengage.track("add_biller", {
          country: billerForm.value.country_name,
          category : billerForm.value.biller_category,
          biller : this.data['biller_name']

        })
        billerForm.reset({country_name:'',biller_category:'',biller_id:''})
        this.toggle()
        this.billerService.message.add({severity:'info', summary: 'Biller added successfully.', detail: ''})

    },err =>{
      this.common.stopLoader()

      this.billerService.message.add({severity:'error', summary: 'Something went wrong', detail: 'Please try again later!'})
      this.billerService.common.stopLoader()
    })
    
    // //console.log(this.data)
    
  }


  toggle(){
    this.toggleButton.nativeElement.click()
  }
}
